"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollToCenter = exports.scrollToNextFocused = void 0;

var isVisible = function isVisible(_ref) {
  var offsetTop = _ref.offsetTop,
      offsetHeight = _ref.offsetHeight,
      parentElement = _ref.parentElement;
  return offsetTop > parentElement.scrollTop && offsetTop + offsetHeight < parentElement.scrollTop + parentElement.offsetHeight;
};

var isOnHover = function isOnHover(node) {
  return node.parentElement.querySelector(':hover') === node;
};

var scrollToNextFocused = function scrollToNextFocused(nextFocused, prevFocused, parent) {
  if (nextFocused === prevFocused) return;
  var el = parent.children[nextFocused];
  if (!el || isOnHover(el) || isVisible(el)) return;

  if (nextFocused > prevFocused) {
    parent.scrollTop = el.offsetTop + el.offsetHeight - parent.offsetHeight;
  } else {
    parent.scrollTop = el.offsetTop;
  }
};

exports.scrollToNextFocused = scrollToNextFocused;

var scrollToCenter = function scrollToCenter(nextFocused, parent) {
  var el = parent.children[nextFocused];
  if (!el) return;
  var parentMiddle = parent.offsetHeight / 2;
  var elMiddle = el.offsetTop + el.offsetHeight / 2;
  parent.scrollTop = elMiddle - parentMiddle;
};

exports.scrollToCenter = scrollToCenter;